import React from 'react';
import ThemeStyle from '../../../lib/style/ThemeStyle';
import Icon from '../atom/Icon';
import { Flex } from '../atom/Layout';
import { Text } from '../atom/Text';
import { TextareaWithCounter } from '../molecules/TextareaWithCounter';

export const TextareaWithHeart = ({
  onClickAddHeart,
  message,
  onChange,
  disabled,
  maxLength,
  placeholder,
}) => (
  <Flex column width="100%">
    {!disabled && (
      <Flex justifyContent="flex-start" width="100%" padding="0 0 0.313rem">
        {[
          { iconName: 'favorite', marginRight: '0.3125rem' },
          { iconName: 'favorite_border', marginRight: '0.625rem' },
        ].map((icon) => (
          <Icon
            key={icon.iconName}
            iconName={icon.iconName}
            onClick={onClickAddHeart}
            style={{
              borderRadius: '1rem',
              border: `1px solid ${ThemeStyle.color.pinkishGrey}`,
              padding: '0.125rem',
              marginRight: icon.marginRight,
            }}
          />
        ))}
        <Text size={12}>하트 입력 시, 클릭해주세요.</Text>
      </Flex>
    )}
    <TextareaWithCounter
      name="message"
      placeholder={placeholder}
      value={message}
      onChange={onChange}
      maxLength={maxLength}
      disabled={disabled}
    />
  </Flex>
);
